module.exports = __webpack_public_path__ + "img/login.5e2adc8f.png";